(function(angular) {
	'use strict';
	/**
	 * Add directives to the audit module
	 */
	var dir = angular.module('Core');
	dir.directive('infoBox', [function() {
			return {
				restrict: 'E',
				template:
						'<div class="alert alert-info infobox">' +
						'	<span class="glyphicon glyphicon-info-sign" style="font-size: 20px;"></span>' +
						'	<span class="infobox-content" ng-transclude></span><div class="spacer"></div>' +
						'</div>',
				replace: true,
				transclude: true,
				scope: false
			};
		}]);

	dir.directive('email', ['$filter', function($filter) {
		return {
			restrict: 'EA',
			template: '<a href="mailto:{{email}}" ng-if="email">{{emailLabel}}</a>',
			scope: {
				email: '=',
				truncateDomain: '@'
			},
			link: function(scope) {
				var setLabel = function(email) {
					var label = email;

					// Desactivation du truncate pour l'instant (attente réactions client, le domain peut être important)
					/*if (!!scope.truncateDomain) {
						label = $filter('truncateEmailDomain')(label);
					}*/

					scope.emailLabel = label;
				};
				setLabel(scope.email);
				scope.$watch('email', function(newVal, oldVal) {
					if (newVal !== oldVal) {
						setLabel(newVal);
					}
				});
			}
		};
		}]);
	dir.directive('mouseListener', [function() {
			return {
				restrict: 'A',
				link: function(scope, element, attribute, controller) {
					$(element).on('mouseenter', function() {
						controller.mouseenter();
					});
					$(element).on('mouseleave', function() {
						controller.mouseleave();
					});
				},
				controller: [function() {
						var listeners = [];
						var sendNotification = function(notification) {
							for (var i = 0; i < listeners.length; i++) {
								listeners[i](notification);
							}
						};
						this.mouseenter = function() {
							sendNotification('mouseenter');
						};
						this.mouseleave = function() {
							sendNotification('mouseleave');
						};
						this.registerForNotification = function(_callBack) {
							listeners.push(_callBack);
						};
				}]
			};
		}]);
	dir.directive('parentMouseListener', [function() {
			return {
				restrict: 'A',
				require: '^mouseListener',
				link: function(scope, element, attribute, controller) {
					var type = attribute['parentMouseListener'];
					var defaultShow = attribute['defaultShow'];
					if (defaultShow && defaultShow === 'hidden') {
						$(element).css('display', 'none');
					}
					controller.registerForNotification(function(notification) {
						if (notification === type) {
							$(element).css('display', '');
						} else {
							$(element).css('display', 'none');
						}
					});
				}
			};
		}]);

	dir.directive('stlTooltipTranslate', ['$translate', function ($translate) {
			return {
				restrict: 'A',
				link: function (scope, element, attr) {
					if (!element.attr('data-placement')) {
						element.attr('data-placement', 'top');
					}
					$translate(element.attr('stl-tooltip-translate')).then(function (translatedValue) {
						element.attr('data-original-title', translatedValue);
					});
					element.tooltip();
				}
			};
		}]);

	dir.directive('stlTooltip', [function() {
		return {
				restrict: 'A',
				link: function (scope, element, attr) {
					if (!element.attr('data-placement')) {
						element.attr('data-placement', 'top');
					}

					if (!attr['stlUpdate']) {
						element.attr('stl-tooltip', 'data-toggle');
						element.tooltip();
					} else {
						scope.$watch(attr['stlUpdate'], function(newValue) {
							if (newValue) {
								element.on('mouseenter', function() {
									element.tooltip('show');
								});
								element.on('click', function() {
									element.tooltip('hide');
								});
							}
						});
					}

					scope.$watch(attr['stlTooltip'], function(newValue) {
						element.attr('data-original-title', newValue);
					});
			}
		};
		}]);



	dir.directive('fixedPosition', [function() {
			return {
				restrict: 'A',
				scope: {},
				link: function(scope, element, attribute) {
					var event = attribute['eventListener'];
					element.css('position', 'relative');
					var currentPosition = 0;
					var update = function(data) {
						var position = (element.offset().top - currentPosition - data.top) * -1;
						if (position < 0) {
							position = 0;
						}
						currentPosition = position;
						element.css('top', currentPosition + 'px');
					};
					if (event === 'body') {
						var body = $('#content');

						body.on('scroll', function(e) {
							update({
								scroll: body.scrollTop(),
								height: body.height(),
								outerHeight: body.outerHeight(),
								innerHeight: body.innerHeight(),
								scrollHeiht: body[0].scrollHeight,
								top: body.offset().top,
								left: body.offset().left
							});
						});
					}

					scope.$on(event + '-scroll', function(e, data) {
						update(data);
					});
					scope.$on(event + '-resize', function(e, data) {
						update(data);
					});
				}
			};
		}]);

	dir.directive('stlTextareaMaxRows', [function() {
			return {
				restrict: 'A',
				link: function(scope, element, attribute) {
					var lines = attribute['stlTextareaMaxRows'];

					element.keydown(function(e) {

						var newLines = $(this).val().split('\n').length;

						if (e.keyCode === 13 && newLines >= lines) {
							return false;
						}

					});
				}
			};
		}]);

	dir.directive('stlLastModification', function($translate, StlDateUtils, $sce, ObjectUtils) {
		return {
			restrict: 'A',

			link: function(scope, element, attr) {
				var ar = false;
				var subPath = attr['subPath'];
				if (attr['typeArray']) {
					ar = true;
				}

				element.attr('data-placement', 'bottom');
				element.attr('stl-tooltip', 'data-toggle');
				element.tooltip({
					'delay': {show: 1000}
				});
				var MAX_LEVEL = 3;

				var getMaxDate = function(object, _lastModification) {

					var lastModification = _lastModification;
					if (object.dateModification && StlDateUtils.convertFromBusinessDateGlobal(object.dateModification).getTime() > _lastModification.dateModification.getTime()) {
						lastModification = {
							dateModification: StlDateUtils.convertFromBusinessDateGlobal(object.dateModification),
							utilisateurModification: object.utilisateurModification
						};
					} else if (object.length) {

						for (var i = 0; i < object.length; i++) {
							var current = object[i];
							if (StlDateUtils.convertFromBusinessDateGlobal(current.dateModification).getTime() > lastModification.dateModification.getTime()) {
								lastModification = {
									dateModification: StlDateUtils.convertFromBusinessDateGlobal(current.dateModification),
									utilisateurModification: current.utilisateurModification
								};
							}
						}


					}

					return lastModification;
				};

				element.addClass('stl-tooltip-info');
				scope.$watch(attr['stlLastModification'], function(newValue) {
					var title;
					var i;
					if (!ar && newValue && newValue.dateModification && !subPath) {
						title = $sce.trustAsHtml($translate.instant('DerniereModification') + '\n' + StlDateUtils.convertToHumainDateWithSecs(newValue.dateModification) + '\n' + newValue.utilisateurModification);
						element.attr('data-original-title', title);
					} else if (ar && newValue && newValue.length && newValue.length > 0) {
						var current = newValue[0];
						var date = StlDateUtils.convertFromBusinessDateGlobal(current.dateModification).getTime();
						title = $translate.instant('DerniereModification') + '\n' + StlDateUtils.convertToHumainDateWithSecs(current.dateModification) + '\n' + current.utilisateurModification;
						for (i = 1; i < newValue.length; i++) {
							current = newValue[i];
							if (StlDateUtils.convertFromBusinessDateGlobal(current.dateModification).getTime() > date) {
								title = $translate.instant('DerniereModification') + '\n' + StlDateUtils.convertToHumainDateWithSecs(current.dateModification) + '\n' + current.utilisateurModification;
								date = StlDateUtils.convertFromBusinessDateGlobal(current.dateModification).getTime();
							}
						}
						element.attr('data-original-title', title);
					} else if (subPath && newValue && newValue.dateModification) {
						var modification = {
							dateModification: StlDateUtils.convertFromBusinessDateGlobal(newValue.dateModification),
							utilisateurModification: newValue.utilisateurModification
						};
						var objectsPath = subPath.split(',');
						for (i = 0; i < objectsPath.length; i++) {
							var obj = ObjectUtils.readPath(newValue, objectsPath[i]);
							modification = getMaxDate(obj, modification);
						}
						title = $sce.trustAsHtml($translate.instant('DerniereModification') + '\n' + StlDateUtils.convertToHumainDateWithSecs(modification.dateModification) + '\n' + modification.utilisateurModification);
						element.attr('data-original-title', title);
					}
				});
			}
		};
	});

	dir.directive('stlNbTranslate', ['$translate', function ($translate) {
		return {
			restrict: 'A',
			link: function (scope, element, attr) {
				var key = attr['stlNbTranslate'];
				var translatedValue = $translate.instant(key);
				if (translatedValue) {
					element.html(translatedValue.replace(/ /g, '&nbsp;'));
				}
			}
		};
		}]);

	dir.directive('stlShortcut', function () {
		return {
			restrict: 'A',
			replace: true,
			scope: true,
			link: function (scope, iElement, iAttrs) {
				jQuery(document).on('keypress', function (e) {
					scope.$apply(scope.keyPressed(e));
				});
			}
		};
	});

	dir.directive('focusOn', function () {
		return function (scope, elem, attr) {
			scope.$on(attr.focusOn, function (e) {
				elem[0].focus();
			});
		};
	});

})(angular);
